export default __webpack_public_path__ + "static/media/paladin-logo-w.f03512f5.png";